export const SELECT_NAVIGATION = 'navigationSelection'
export function selectNavigation (node) {
  return {
    type: SELECT_NAVIGATION,
    node
  }
}
